// expo quick actions DOES NOT work without the wildcard.
// eslint-disable-next-line no-restricted-syntax
import * as QuickActions from 'expo-quick-actions';
import { useQuickActionCallback } from 'expo-quick-actions/hooks';
import { useEffect } from 'react';
import { Linking } from 'react-native';

const useAppQuickActions = (actions: QuickActions.Action[]) => {
  useQuickActionCallback((action) => {
    const route = action.params?.href;
    if (route) {
      Linking.emit('url', { url: route });
    }
  });

  useEffect(() => {
    void QuickActions.setItems(actions);
  }, [actions]);
};

export default useAppQuickActions;
